var _g, _g2, _path, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6730_34112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3181 15.0685C25.3181 10.5498 21.655 6.88672 17.1363 6.88672C12.6176 6.88672 8.95448 10.5498 8.95448 15.0685C8.95448 19.5872 12.6176 23.2504 17.1363 23.2504C18.5725 23.2504 19.9238 22.8798 21.0982 22.2287C21.17 22.1889 21.24 22.1872 21.2898 22.2048L23.2098 22.8832C24.3861 23.2989 25.5193 22.1657 25.1036 20.9894L24.3971 18.99C24.3801 18.942 24.3809 18.875 24.4169 18.8049C24.9931 17.6842 25.3181 16.4135 25.3181 15.0685Z",
    fill: "url(#paint0_linear_6730_34112)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6730_34112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68188 11.4318C1.68188 6.91312 5.34501 3.25 9.8637 3.25C14.3824 3.25 18.0455 6.91312 18.0455 11.4318C18.0455 15.9505 14.3824 19.6136 9.8637 19.6136C8.42753 19.6136 7.07619 19.2431 5.90181 18.592C5.82995 18.5522 5.76003 18.5505 5.71018 18.5681L3.79024 19.2465C2.61389 19.6622 1.48075 18.529 1.89642 17.3527L2.60293 15.3532C2.61989 15.3053 2.61911 15.2383 2.58306 15.1682C2.00685 14.0475 1.68188 12.7768 1.68188 11.4318Z",
    fill: "url(#paint1_linear_6730_34112)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8637 2.75C5.06887 2.75 1.18188 6.63698 1.18188 11.4318C1.18188 12.8206 1.50874 14.1359 2.09059 15.3024L1.42499 17.1861C0.869276 18.7587 2.38417 20.2736 3.95683 19.7179L5.75611 19.0821C6.98002 19.7405 8.37981 20.1136 9.8637 20.1136C14.6585 20.1136 18.5455 16.2267 18.5455 11.4318C18.5455 6.63698 14.6585 2.75 9.8637 2.75Z",
    stroke: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6730_34112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68188 11.4318C1.68188 6.91312 5.34501 3.25 9.8637 3.25C14.3824 3.25 18.0455 6.91312 18.0455 11.4318C18.0455 15.9505 14.3824 19.6136 9.8637 19.6136C8.42753 19.6136 7.07619 19.2431 5.90181 18.592C5.82995 18.5522 5.76003 18.5505 5.71018 18.5681L3.79024 19.2465C2.61389 19.6622 1.48075 18.529 1.89642 17.3527L2.60293 15.3532C2.61989 15.3053 2.61911 15.2383 2.58306 15.1682C2.00685 14.0475 1.68188 12.7768 1.68188 11.4318Z",
    fill: "url(#paint2_linear_6730_34112)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_6730_34112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36168 11.4715C7.36168 12.0835 6.86553 12.5797 6.25349 12.5797C5.64145 12.5797 5.14529 12.0835 5.14529 11.4715C5.14529 10.8594 5.64145 10.3633 6.25349 10.3633C6.86553 10.3633 7.36168 10.8594 7.36168 11.4715Z",
    fill: "#A7AEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9417 11.4715C10.9417 12.0835 10.4455 12.5797 9.83347 12.5797C9.22144 12.5797 8.72528 12.0835 8.72528 11.4715C8.72528 10.8594 9.22144 10.3633 9.83347 10.3633C10.4455 10.3633 10.9417 10.8594 10.9417 11.4715Z",
    fill: "#A7AEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5217 11.4715C14.5217 12.0835 14.0255 12.5797 13.4135 12.5797C12.8014 12.5797 12.3053 12.0835 12.3053 11.4715C12.3053 10.8594 12.8014 10.3633 13.4135 10.3633C14.0255 10.3633 14.5217 10.8594 14.5217 11.4715Z",
    fill: "#A7AEBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6730_34112",
    x: 8.95447,
    y: 6.88672,
    width: 16.3636,
    height: 16.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6730_34112",
    x: 0.681885,
    y: 2.25,
    width: 18.3636,
    height: 18.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6730_34112",
    x: 1.68188,
    y: 3.25,
    width: 16.3636,
    height: 16.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_6730_34112",
    x: 5.14529,
    y: 10.3633,
    width: 9.37637,
    height: 2.2168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6730_34112",
    x1: 17.1363,
    y1: 6.88672,
    x2: 17.1363,
    y2: 23.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4ABB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6730_34112",
    x1: 9.8637,
    y1: 3.25,
    x2: 9.8637,
    y2: 19.6136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6730_34112",
    x1: 9.8637,
    y1: 3.25,
    x2: 9.8637,
    y2: 19.6136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD5DF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.bcf4a09bdc7d16674f1e454f4a45fc8f.svg";
export { ForwardRef as ReactComponent };